import React, { useEffect, useState } from "react";
import Filter from "./filter";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import Input from "antd/lib/input/Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import EmptyDashboardData from "../toBeAccountantContent/emptyDashboardData";
import InfiniteScroll from "react-infinite-scroller";
import { getAccountedEntries } from "../../../store/actions/precog/accountedEntries";
import { getDraftIdFromOriginalEntry } from "../../../store/actions/precog";
import { openNotificationWithIcon } from "../../../libs/utils";
import { notification } from "antd";

const AccountantContent = ({
  isActiveValue,
  categories,
  uuidCurrentFilter,
  setUuidCurrentFilter,
  filterChips,
  setFilterChips,
  setDocNumberFilter,
  docNumberFilter,
  accountCodeFilter,
  setAccountCodeFilter,
  movementsFiltersChips,
  setMovementsFiltersChips,
  includesFilter,
  onCheckIncludesFilter,
  onChangeDocDate,
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,
  closeMoreFilter,
  setCloseMoreFilter,
  monthsSelectValue,
  setMonthsSelectValue,
  months,
  setMonths,
  yearFilter,
  setYearFilter,
  quarterFilter,
  setQuarterFilter,
  isBankTransactionActive,
  setIsBankTransactionActive,
  tabActive
}) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [generalLedgerData, setGeneralLedgerData] = useState([]);
  const [deleteSpinner, setDeleteSpinner] = useState(false);
  const [clickedItem, setClickedItem] = useState(null);
  const accountedEntries = useSelector(state => state?.precog?.accountedEntries?.data?.entries);
  const isGettingDashboardData = useSelector((state) => state.precog.dashboardData.status?.started);

  // const [urlNextPage, seturlNextPage] = useState(null);

  useEffect(() => {
    dispatch(getAccountedEntries(
      null, null, dateFrom, dateTo, null, includesFilter.length > 0 ? includesFilter : null
    )).then((res) => {
      setGeneralLedgerData(res?.data);
    });
  }, [dateFrom, dateTo, includesFilter]);

  const accountedEntriesStatus = useSelector(state => state?.precog?.accountedEntries?.status);
  const intl = useIntl();
  const [dataTable, setDataTable] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [filtersTable, setFiltersTable] = useState(null);
  const [isCompanyFilterActive, setIsCompanyFilterActive] = useState(true);
  const [isAccountingReasonFilterActive, setIsAccountingReasonFilterActive] = useState(true);

  useEffect(() => {
    if (Array.isArray(accountedEntries)) {
      const calculatedDataTable = accountedEntries.map((d, index) => {
        const company = d?.supplier?.name === undefined ? d?.customer?.name : d?.supplier?.name;
        return {
          key: index,
          registrationDate: d?.postingDate,
          originalEntryId: d?.originalEntryId,
          dateOfReceipt: d?.postingDate,
          company: company,
          accountingReason: d?.reasonDescription,
          dataDoc: d?.doc?.date,
          docNumber: d?.doc?.number,
          amount: `${numeral(Math.abs(d?.totalAmount?.value)).format("0,0.00")} €`,
          id: d?.id
        };
      });
      setDataTable(calculatedDataTable);
    }
  }, [accountedEntries]);

  useEffect(() => {
    setFilteredList(dataTable);
  }, [dataTable]);

  useEffect(() => {
    const filterNew = dataTable?.filter(function(item) {
      for (let key in filtersTable) {
        if (filtersTable[key] && (item[key] === undefined || !(item[key].toString()).includes(filtersTable[key])))
          return false;
      }
      return true;
    });

    setFilteredList(filterNew);

  }, [filtersTable]);

  const handleChange = (filterKey, value) => {
    setFiltersTable({
      ...filtersTable,
      [filterKey]: value
    });
  };

  const handleCompanyFilter = value => {
    if (isCompanyFilterActive) {
      handleChange("company", value);
    } else {
      setFiltersTable(null);
      setFilteredList(dataTable);
    }
  };

  const setterCompanyFilter = value => {
    setIsCompanyFilterActive(!isCompanyFilterActive);
    handleCompanyFilter(value);
  };

  const handleAccountingReasonFilter = value => {
    if (isAccountingReasonFilterActive) {
      handleChange("accountingReason", value);
    } else {
      setFiltersTable(null);
      setFilteredList(dataTable);
    }
  };

  const setterAccountingReasonFilter = value => {
    setIsAccountingReasonFilterActive(!isAccountingReasonFilterActive);
    handleAccountingReasonFilter(value);
  };

  const initial = {
    key: "initial",
    registrationDate: "initial",
    dateOfReceipt: "initial",
    company: "initial",
    accountingReason: "initial",
    dataDoc: "initial",
    docNumber: "initial",
    amount: "initial",
    id: "initial",
    originalEntryId: "initial"
  };

  const goToDetail = (accountedEntries) => {
    dispatch(getDraftIdFromOriginalEntry(accountedEntries.originalEntryId)).then((res) => {
      setDeleteSpinner(false);
      navigate({pathname: `/precog-detail/${res}`}, {state: {isFromAccountantTable: true}});
    }).catch(err => {
      setDeleteSpinner(false);
      openNotificationWithIcon(
        notification,
        "error",
        "",
        intl.formatMessage({id: "preCog.accountantContent.errorMessage"}),
        null,
        null
      );
    });
  };

  const columns = [
    {
      title: intl.formatMessage({ id: "preCog.accountantContent.registration"}),
      key: "registrationDate",
      dataIndex: "registrationDate",
      render: value => (value === "initial" ? "" : moment(value).format("DD/MM/YYYY"))
    },
    {
      title: intl.formatMessage({ id: "preCog.accountantContent.receiptDate" }),
      key: "dateOfReceipt",
      dataIndex: "dateOfReceipt",
      render: value => (value === "initial" ? "" : moment(value).format("DD/MM/YYYY"))
    },
    {
      title: intl.formatMessage({ id: "preCog.accountantContent.company" }),
      key: "company",
      dataIndex: "company",
      width: 300,
      render: value => (value === "initial" ?
        <Input
          className="input-search transparent"
          allowClear={true}
          suffix={<FontAwesomeIcon
            icon={["far", "search"]}
          />}
          onChange={(e) => handleChange("company", e.target.value)}
        />:
        <div className="filterable" onClick={() => setterCompanyFilter(value)} >
          {<span>{value}</span>}
          <FontAwesomeIcon
            style={{ color: "#0090d1", marginRight: "16px" }}
            icon={[isCompanyFilterActive ? "fal" : "fas", isCompanyFilterActive ? "filter" : "times"]}
          />
        </div>)
    },
    {
      title: intl.formatMessage({ id: "preCog.accountantContent.accountingReason" }),
      key: "accountingReason",
      dataIndex: "accountingReason",
      width: 300,
      render: value => (value === "initial" ?
        <Input
          className="input-search transparent"
          allowClear={true}
          suffix={<FontAwesomeIcon
            icon={["far", "search"]}
          />}
          onChange={(e) => handleChange("accountingReason", e.target.value)}
        />:  <div className="filterable" onClick={() => setterAccountingReasonFilter(value)} >
          {<span>{value}</span>}
          <FontAwesomeIcon
            style={{ color: "#0090d1", marginRight: "16px" }}
            icon={[isAccountingReasonFilterActive ? "fal" : "fas", isAccountingReasonFilterActive ? "filter" : "times"]}
          />
        </div>)
    },
    {
      title: intl.formatMessage({ id: "preCog.accountantContent.dataDoc" }),
      key: "dataDoc",
      dataIndex: "dataDoc",
      render: value => (value === "initial" ? "" : moment(value).format("DD/MM/YYYY"))
    },
    {
      title: intl.formatMessage({ id: "preCog.accountantContent.docNumber" }),
      key: "docNumber",
      dataIndex: "docNumber",
      render: value => (value === "initial" ? "" : value)
    },
    {
      title: intl.formatMessage({ id: "preCog.accountantContent.amount" }),
      key: "amount",
      dataIndex: "amount",
      render: value => (value === "initial" ? "" : value)
    },
    {
      title: "",
      key: "id",
      dataIndex: "id",
      render: (value, record) => {
        return <div style={{ minWidth: 50 }}>{
          value !== "initial" && ((deleteSpinner && record === clickedItem) ?
            <FontAwesomeIcon icon={["far", "circle-notch"]} style={{fontSize: "15px", color: "#0090d1", cursor: "pointer"}} spin/> :
            <FontAwesomeIcon
              icon={["far", "arrow-right"]}
              style={{color: "#0090d1", cursor: "pointer"}}
              onClick={() => {
                goToDetail(record);
                setDeleteSpinner(true);
                setClickedItem(record);
              }}
            />)
        }
        </div>;
      }
    }
  ];

  const loader = (
    <div
      style={{ position: "sticky", top: "50vh", /* top: "64px", */
        backgroundColor: "rgba(256,256,256, 0.7)",
        width: "calc(100% - 64px)",
        height: "calc(100% - 64px)",
        zIndex: 9,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center", fontSize: "32px", color: "#0090d1", left: "64px" }}
    >
      <FontAwesomeIcon icon={["far", "circle-notch"]} spin />
    </div>
  );

  return (
    <>
      <Filter
        closeMoreFilter={closeMoreFilter}
        setCloseMoreFilter={setCloseMoreFilter}
        monthsSelectValue={monthsSelectValue}
        setMonthsSelectValue={setMonthsSelectValue}
        months={months}
        setMonths={setMonths}
        yearFilter={yearFilter}
        setYearFilter={setYearFilter}
        quarterFilter={quarterFilter}
        setQuarterFilter={setQuarterFilter}
        isBankTransactionActive={isBankTransactionActive}
        setIsBankTransactionActive={setIsBankTransactionActive}
        filterChips={filterChips}
        setFilterChips={setFilterChips}
        docNumberFilter={docNumberFilter}
        setDocNumberFilter={setDocNumberFilter}
        accountCodeFilter={accountCodeFilter}
        setAccountCodeFilter={setAccountCodeFilter}
        movementsFiltersChips={movementsFiltersChips}
        setMovementsFiltersChips={setMovementsFiltersChips}
        includesFilter={includesFilter}
        onCheckIncludesFilter={onCheckIncludesFilter}
        onChangeDocDate={onChangeDocDate}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        dateFrom={dateFrom}
        dateTo={dateTo}
        setUuidCurrentFilter={setUuidCurrentFilter}
        tabActive={tabActive}
      />
      {(accountedEntriesStatus?.ended && generalLedgerData?.entries?.length > 0 && filteredList?.length === 0) ?
        <EmptyDashboardData>
          <>
            <p className="empty-dashboard-text"><FormattedMessage id="preCog.accountingTab.noResults_filtered" /></p>
            <p className="empty-dashboard-text"><FormattedMessage id="preCog.accountingTab.noResults_tryAgain" /></p>
          </>
        </EmptyDashboardData>
        :
        (accountedEntriesStatus?.ended && generalLedgerData?.entries?.length === 0) ?
          <EmptyDashboardData>
            <>
              <p className="empty-dashboard-text"><FormattedMessage id="preCog.accountingTab.noResults_accounted" /></p>
            </>
          </EmptyDashboardData>
          :
          <InfiniteScroll
            initialLoad={false}
            pageStart={1}
            loader={isGettingDashboardData && loader}
            threshold={30}
            useWindow={false}
            getScrollParent={() => document.getElementById("dbx-main-container")}
          >
            <Table
              className="vaporTable"
              columns={columns}
              dataSource={[initial, ...filteredList]}
              pagination={false}
            />
          </InfiniteScroll>
      }

    </>
  );
};

export default AccountantContent;
